/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback, useState, useEffect } from "react";
import { InlineEdit } from "../../components/InlineEdit";
import { Button } from "../../components/Button";
import { useParams } from "react-router-dom";
import getCroppedImg from "../../utils/cropImage";
import useSaveTemplate from "../../utils/customHooks";
import ImageUploader from "../../utils/ImageUploader";
import { CropperWrapper } from "../../utils/CropperWrapper";
import { SpinnerOverlay } from "../../utils/SpinnerOverlay";

export const Basnie20: React.FC = () => {
  const { pdfNameFromUrl } = useParams<{ pdfNameFromUrl: string }>();
  const [text1, setText1] = useState<string>("Bajeczki księżniczki");
  const [text2, setText2] = useState<string>("Karoliny");
  const [text3, setText3] = useState<string>("Niech Twój świat będzie jak najpiękniejsza bajka");
  const [text4, setText4] = useState<string>("Ciocia Agata i Wujek Wojtek");

  const text1BasicSize = 66;
  const text2BasicSize = 106;
  const text3BasicSize = 40;
  const text4BasicSize = 40;
  const [fontSizeText1, setFontSizeText1] = useState<number>(text1BasicSize);
  const [fontSizeText2, setFontSizeText2] = useState<number>(text2BasicSize);
  const [fontSizeText3, setFontSizeText3] = useState<number>(text3BasicSize);
  const [fontSizeText4, setFontSizeText4] = useState<number>(text4BasicSize);
  const { saveTemplate, isSaving } = useSaveTemplate();

  const [image, setImage] = useState<string | null>(null);
  const [croppedImage, setCroppedImage] = useState<string | null>(null);
  const [crop, setCrop] = useState<{ x: number; y: number }>({ x: 0, y: 0 });
  const [zoom, setZoom] = useState<number>(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<any>(null);
  const [step, setStep] = useState<"select" | "crop" | "view">("select");

  const pdfWidth = "250mm"; // PDF width in mm
  const pdfHeight = "300mm"; // PDF height in mm
  const maxWidth = 850; // Maximum width for text
  const adjustFontSize = (
    text: string,
    currentFontSize: number,
    maxFontSize: number,
    minFontSize: number
  ) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    if (context) {
      let newFontSize = currentFontSize;
      context.font = `${newFontSize}px 'DJBSandShoes'`;
      let textWidth = context.measureText(text).width;

      while (textWidth > maxWidth && newFontSize > minFontSize) {
        newFontSize -= 1;
        context.font = `${newFontSize}px 'DJBSandShoes'`;
        textWidth = context.measureText(text).width;
      }

      while (textWidth < maxWidth * 0.9 && newFontSize < maxFontSize) {
        newFontSize += 1;
        context.font = `${newFontSize}px 'DJBSandShoes'`;
        textWidth = context.measureText(text).width;
      }

      return newFontSize;
    }

    return currentFontSize;
  };

  useEffect(() => {
    setFontSizeText1(adjustFontSize(text1, fontSizeText1, text1BasicSize, 10));
  }, [text1]);

  useEffect(() => {
    setFontSizeText2(adjustFontSize(text2, fontSizeText2, text2BasicSize, 10));
  }, [text2]);

  useEffect(() => {
    setFontSizeText3(adjustFontSize(text3, fontSizeText3, text3BasicSize, 10));
  }, [text3]);

  useEffect(() => {
    setFontSizeText4(adjustFontSize(text4, fontSizeText4, text4BasicSize, 10));
  }, [text4]);

  const handleSave = () => {
    saveTemplate(
      "printable-content",
      {
        pdfWidth: pdfWidth,
        pdfHeight: pdfHeight,
        pdfNameFromUrl: pdfNameFromUrl,
      },
      croppedImage,
      true
    );
  };
  const handleCropComplete = useCallback((croppedArea: any, croppedAreaPixels: any) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleShowCroppedImage = useCallback(async () => {
    if (image && croppedAreaPixels) {
      // Function to crop the image and get the result
      const croppedImg = await getCroppedImg(image, croppedAreaPixels); // Replace with your image cropping logic
      setCroppedImage(croppedImg);
      setStep("view");
    }
  }, [image, croppedAreaPixels]);

  return (<div style={{
    width: "100%",
    height: "100%",
    backgroundColor: "#ffffff", padding: "60px",
    position: "relative",
  }}>
    {/* Spinner Overlay */}
    <SpinnerOverlay isVisible={isSaving} />
    <div style={{ position: "absolute", top: "10px", left: "0px", right: "0px", margin: "auto", color: "white", width: "480px", maxWidth: "100%", height: "70px", gap: "30px", display: "flex", alignItems: "center" }}>
      <ImageUploader
        onImageChange={(image) => setImage(image)}
        setStep={setStep}
      />
      {step === "crop" && (
        <p>
          Aby wykadrować zdjęcie możesz kręcić kółkiem myszy i przesuwać obraz
        </p>
      )}
      {step !== "crop" && (
        <Button onClick={handleSave} disabled={isSaving}>
          {isSaving ? "Zapisywanie..." : "Zapisz"}
        </Button>
      )}
      {step === "crop" && (
        <Button onClick={handleShowCroppedImage}>Zakończ kadrowanie</Button>
      )}
    </div>

    <div
      id="printable-content"
      style={{
        position: "relative",
        width: pdfWidth,
        height: pdfHeight,
        fontFamily: "kissmeornot, AmaticSCBold, AmaticSC",
        backgroundColor: "#ffffff",
        margin: "auto",
        marginTop: "20px"
      }}
    >          <InlineEdit
        value={text1}
        setValue={setText1}
        style={{
          fontSize: `${fontSizeText1}px`,
          lineHeight: `${fontSizeText1}px`,
          width: `${maxWidth}px`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: 'absolute',
          top: '60px', // Zmienione położenie
          margin: 'auto',
          left: '0',
          right: '0',
          fontFamily: 'kissmeornot',
          color: "#ec8c75",
          zIndex: "12",
          textAlign: "center",
          fontWeight: "400",
        }}
      />
      <InlineEdit
        value={text2}
        setValue={setText2}
        style={{
          fontSize: `${fontSizeText2}px`,
          lineHeight: `${fontSizeText2}px`,
          width: `${maxWidth}px`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: 'absolute',
          top: '130px', // Zmienione położenie
          margin: 'auto',
          left: '0',
          right: '0',
          fontFamily: 'kissmeornot',
          color: "#ec8c75",
          zIndex: "12",
          textAlign: "center",
          fontWeight: "400",
        }}
      />
      <InlineEdit
        value={text3}
        setValue={setText3}
        style={{
          fontSize: `${fontSizeText3}px`,
          lineHeight: `${fontSizeText3}px`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: 'absolute',
          bottom: '146px', // Zmienione położenie
          margin: 'auto',
          left: '0',
          right: '0',
          fontFamily: 'AmaticSCBold',
          color: "#daa26d",
          zIndex: "12",
          textAlign: "center",
          fontWeight: "400",
          letterSpacing: "0.0001em"
        }}
      />

      <InlineEdit
        value={text4}
        setValue={setText4}
        style={{
          fontSize: `${fontSizeText4}px`,
          lineHeight: `${fontSizeText4}px`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: 'absolute',
          bottom: '86px', // Zmienione położenie
          margin: 'auto',
          left: '0',
          right: '152px',
          fontFamily: 'AmaticSC',
          color: "#daa26d",
          zIndex: "12",
          textAlign: "right",
          fontWeight: "400",
          letterSpacing: "0.0001em"
        }}
      />
      {/* Step: Crop */}
      {image && step === "crop" && (
        <CropperWrapper
          image={image}
          crop={crop}
          zoom={zoom}
          aspect={120 / 134}
          cropShape="round"
          onCropChange={setCrop}
          onZoomChange={setZoom}
          onCropComplete={handleCropComplete}
          style={{
            top: "83.5mm",
            left: "491px",
            width: "120mm",
            height: "134mm",
            zIndex: 5
          }}
        />
      )}

      {/* Step: View */}
      {croppedImage && step === "view" && (
        <img
          src={croppedImage}
          style={{
            position: "absolute",
            top: "83.5mm",
            left: "491px",
            width: "120mm",
            height: "134mm",
            transform: "translateX(-50%)",
            borderRadius: "50%",
            zIndex: 2,
          }}
        />
      )}

      {/* <img
          src="/images/Basnie20overlay.svg"
          style={{
            position: "absolute",
            zIndex: 5,
            width: "100%",
            height: "100%",
          }}
        /> */}
      <img
        src="/images/Basnie20.svg"
        style={{ width: "100%", height: "100%", position: "relative", zIndex: 3 }}
      />
    </div>
  </div>
  );
};